import { ReactNode } from "react";
import clsx from "clsx";
import PulseDot from "./pulse-dot";
import { TONES, Tone } from "./tones";

export default function StatusPill({ tone, children, live = false, className }: { tone: Tone; children: ReactNode; live?: boolean; className?: string }) {
  return (
    <span className={clsx("inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-1 font-[Gilroy-Medium] text-[12px]", TONES[tone].soft, TONES[tone].text, className)}>
      <PulseDot tone={tone} live={live} className="!h-2 !w-2" />
      {children}
    </span>
  );
}
